import { useEffect, useState } from "react";
import { io } from "socket.io-client";

const socket = io("https://lghrequests.com", {
  transports: ["websocket"]
});

function App() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {

    // =====================
    // DEBUG
    // =====================
    socket.on("connect", () => {
      console.log("🟢 SOCKET CONNECTED:", socket.id);
    });

    socket.onAny((event, data) => {
      console.log("📡 EVENT:", event, data);
    });

    // =====================
    // INIT LOAD
    // =====================
    fetch("https://lghrequests.com/api/orders")
      .then(res => res.json())
      .then(data => setOrders(data));

    // =====================
    // NEW ORDER
    // =====================
    socket.on("order:new", (order) => {
      setOrders(prev => [order, ...prev]);
    });

    // =====================
    // UPDATE ORDER
    // =====================
    socket.on("order:update", (updated) => {
      setOrders(prev =>
        prev.map(o =>
          String(o.id) === String(updated.id)
            ? { ...o, status: updated.status }
            : o
        )
      );
    });

    return () => {
      socket.off("order:new");
      socket.off("order:update");
    };

  }, []);

  return (
    <div style={{
      padding: 30,
      fontFamily: "Arial",
      background: "#0f172a",
      minHeight: "100vh",
      color: "white"
    }}>
      <h1>📦 LINE Dashboard (Realtime)</h1>

      <div style={{ marginTop: 20 }}>
        {orders.map(o => (
          <div key={o.id} style={{
            padding: 15,
            marginBottom: 10,
            background: o.status === "done" ? "#14532d" : "#1e293b",
            borderRadius: 10
          }}>
            <div><b>TEXT:</b> {o.text}</div>
            <div><b>STATUS:</b> {o.status}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default App;